import { render } from "./AppLayoutDefault.vue?vue&type=template&id=30054efc"
const script = {}
script.render = render

export default script